import { useResponsiveScale } from '../../hooks/useResponsiveRem';
import { BUTTON_RADII_PX, type ButtonSizeKey } from '../../styles/button-radii';

/**
 * Resolves the Figma-spec px radii for a button size, scaled by the current
 * responsive factor. On web `useResponsiveScale()` returns 1 (CSS rem
 * already handles browser zoom / OS text-size), so the values returned
 * here equal the raw JSON. On native the values track `useWindowDimensions`
 * and `PixelRatio.getFontScale()` per the iPad + accessibility cap policy
 * defined in `computeResponsiveRem`.
 *
 * Returned numbers are rounded to 3 decimals so React's style diffing
 * doesn't churn on float drift across re-renders.
 */
export function useScaledButtonRadii(size: ButtonSizeKey): {
  inner: number;
  outerTop: number;
  outerBottom: number;
} {
  const scale = useResponsiveScale();
  const r = BUTTON_RADII_PX[size];
  return {
    inner: Math.round(r.inner * scale * 1000) / 1000,
    outerTop: Math.round(r.outerTop * scale * 1000) / 1000,
    outerBottom: Math.round(r.outerBottom * scale * 1000) / 1000,
  };
}
